import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class DesignAPIs {
  static async getThemesList() {
    return (await $http.get('/themes')).data
  }

  static async getTheme(branchId: number, platform: 'mobile' | 'ipad', id: number) {
    return (await $http.get(`/themes/${branchId}`)).data[platform].find((theme: any) => theme.id === id)
  }

  static async updateOrCreate(platform: 'mobile' | 'ipad', payload: FormData) {
    return (await $http.post(`/themes/${platform}`, payload, { headers: FormsService.MULTIPART_HEADER })).data
  }

  static async delete(platform: 'mobile' | 'ipad', id: number) {
    return (await $http.delete(`/themes/${platform}/${id}`)).data
  }

  static async activate(platform: 'mobile' | 'ipad', branch_id: number, id: number, forMobile = false) {
    return (await $http.put(`/themes/activate/${platform}/${id}`, { branch_id, mobile: forMobile })).data
  }

  static async duplicate(platform: 'mobile' | 'ipad', branch_id: number, id: number) {
    return (await $http.put(`/themes/duplicate/${platform}/${id}`, { branch_id })).data
  }
}

export default DesignAPIs
